import _ from "lodash";
import React, { Component } from "react";
import styled from "styled-components";
import qs from "qs";
import { connect } from "react-redux";
import {
  updateCalculator,
  fetchDurations,
  updateCalculatorPrice
} from "../../../actions/calculator";
import Banner from "../../Calculator/Banner";
import CalendarIcon from "../../UI/Icons/CalendarIcon";
import Button from "../../UI/Button";
import { Wrapper, Caret } from "./Step0";
import { ButtonWrapper } from "./Step3";
import DurationCard from "../../Calculator/Card/DurationCard";
import { fluidType, device, getNetPrice, getTax } from "../../../utils/helpers";

const Content = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 24px;

  @media ${device.mobileM} {
    justify-content: space-around;
  }

  @media ${device.tablet} {
    flex-wrap: nowrap;
    margin-top: 0.9375vw;
  }
`;

const Info = styled.div`
  display: flex;
  flex-direction: column;
  background: #f3f3f3;
  justify-content: center;
  padding: 32px 0;
  text-align: center;
  margin-top: 24px;

  @media ${device.tablet} {
    margin-top: 0.9375vw;
    padding: 1.6666666666666667vw 0;
  }
`;

const InfoQuestion = styled.p`
  font-family: "BarlowExtraBold";
  text-transform: uppercase;
  font-size: 21px;
  padding-bottom: 25px;

  @media ${device.tablet} {
    font-size: 1.09375vw;
    padding-bottom: 1.3020833333333335vw;
  }
`;

const InfoAnswer = styled.p`
  font-family: "BarlowSemiBold";
  ${props =>
    fluidType(
      props.theme.screen.mobile,
      props.theme.screen.desktop,
      "16px",
      "18px"
    )};
`;

const Calendar = styled(CalendarIcon)`
  ${"" /* 80 */} width: 4.166666666666667vw;
`;

class Step5 extends Component {
  componentDidMount() {
    // Fetch all the durations
    this.props.fetchDurations(this.props.total);
    // Set the current step to active and visited
    this.props.updateCalculator(6, {
      active: true,
      visited: true
    });
  }

  updateDurationPrices(duration) {
    // Update the coefficient and average state
    this.props.updateCalculatorPrice(
      duration.coefficient,
      duration.average_days
    );
    const data = {
      name: "Logistica",
      active: true,
      visited: true,
      selectedComponent: duration.name,
      price: duration.logistics_amount
    };
    this.props.updateCalculator(5, data);
    this.props.updateCalculator(6, {
      selectedComponent: duration.name
    });

    localStorage.setItem('duration_selected', duration.average_days);
  }

  handleNextClick() {
    const { durations, average } = this.props;
    const { sport } = this.props.match.params;
    const variant = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true
    }).variant;
    const path = `/noleggia/${sport}/7?variant=${variant}`;
    // Get the selected duration by checking if the average is the same
    const selectedDuration = _.find(durations, { average_days: average });
    const data = {
      active: true,
      visited: true,
      selectedComponent: selectedDuration.name
    };
    this.props.updateCalculator(6, data);
    this.props.history.push(path);
  }

  render() {
    const { durations, average } = this.props;
    const { sport } = this.props.match.params; // Sport token from URL
    const currentVariant = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true
    }).variant;

    return (
      <Wrapper>
        <Banner
          icon={<Calendar fill="#fca317" />}
          title="DURATA NOLEGGIO"
          subtitle="PER QUANTO TEMPO HAI;BISOGNO DELLE STRUTTURE?"
        />
        <Content>
          {durations.map((duration, index) => {
            return (
              <DurationCard
                duration={duration.name}
                key={index}
                selected={average === duration.average_days}
                onClick={this.updateDurationPrices.bind(this, duration)}
                price={duration.final_amount}
                total={getNetPrice(duration.final_amount)}
                tax={getTax(duration.final_amount)}
              />
            );
          })}
        </Content>
        <Info>
          <InfoQuestion>
            NON TROVI LA SOLUZIONE <br /> GIUSTA PER TE?
          </InfoQuestion>
          <InfoAnswer>
            Seleziona l’opzione più vicina alle tue esigenze,<br />specifica le
            tue richieste nel prossimo step!
          </InfoAnswer>
        </Info>
        <ButtonWrapper>
          <Button
            to={`/noleggia/${sport}/5?variant=${currentVariant}`}
            size="small"
          >
            <Caret transform="rotate(180)" fill="#fff" /> &nbsp;&nbsp; STEP
            PRECEDENTE
          </Button>
          <Button onClick={this.handleNextClick.bind(this)} size="small">
            STEP SUCCESSIVO &nbsp;&nbsp; <Caret fill="#fff" />
          </Button>
        </ButtonWrapper>
      </Wrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    durations: state.calculator.durations,
    total: state.calculator.total,
    average: state.calculator.average
  };
}

export default connect(
  mapStateToProps,
  { updateCalculator, fetchDurations, updateCalculatorPrice }
)(Step5);



// WEBPACK FOOTER //
// ./src/components/Pages/Calculator/Step6.js